import React from 'react';
import BaseTemplate from './BaseTemplate';

const ExperiencedTemplate = ({ data }) => {
  return <BaseTemplate data={data} />;
};

export default ExperiencedTemplate;
